// import mobileDetect from "mobile-detect"

// //Init search bar if user is NOT on mobile device
// var md = new mobileDetect(window.navigator.userAgent);
// if (!md.mobile()) {
//     initSearchBar()
// }

// function initSearchBar() {
//     alert("desk");
// }

import { autocomplete } from "@algolia/autocomplete-js";

function debouncePromise(fn, delay) {
    let timerId;

    return (...args) => {
        // Clear any existing timer
        if (timerId) {
            clearTimeout(timerId);
        }

        // Return a new promise, resolving after the debounce delay
        return new Promise((resolve, reject) => {
            timerId = setTimeout(() => {
                try {
                    resolve(fn(...args));
                } catch (error) {
                    reject(error);
                }
            }, delay);
        });
    };
}
const debouncedFetch = debouncePromise(fetch, 300)

document.addEventListener("DOMContentLoaded", function () {

    autocomplete({
        container: "#autocomplete",
        placeholder: "Search for products",
        detachedMediaQuery: "(max-width: 767px)",
        getSources({ query }) {
            return debouncedFetch(`/ajax/search?q=${query}`)
                .then(res => res.json())
                .then(data => {
                    return [
                        {
                            sourceId: "products",
                            getItems() {
                                return data
                            },
                            getItemUrl({ item }) {
                                return `/product/${item.slug}/${item.id}`
                            },
                            templates: {
                                item({ item, html }) {
                                    return html`<a href="/product/${item.slug}/${item.id}" class="search-link">
                                    <div class="row align-items-center" >
                                        <div class="col-auto">
                                            <img src="${item.img || '\/assets\/images\/no-image.gif'}" width="60" />
                                        </div>
                                        <div class="col">
                                            ${item.name}                                                
                                        </div>
                                    </div>
                                </a>`
                                },
                                noResults() {
                                    return `No results found`
                                }
                            }
                        }
                    ]
                })
        },
        onSubmit({ state }) {
            const query = state.query;
            if (query.trim()) {
                window.location.href = `/search?q=${query}`
            }
        }
    });
    

});

